module.exports = __webpack_public_path__ + "static/media/full-screen-shot.8303ed7a.png";